module.exports = __webpack_public_path__ + "img/account_icon.90695bc7.svg";